// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-bfcb0ab9572b0233f0f0b57d7e3b9d62","ul":"Navigation-ul-0eb92570881014092307089872e930e4"};